export default class ContactsMap {
	constructor() {
		this.map = document.querySelector('[data-contacts-map]');

		if (!this.map) return false;

		this.center = this.map.dataset.center.split(',');
		this.zoom = this.map.dataset.zoom;
		this.cords = this.map.dataset.cords.split(';');
		if(this.map.dataset.balloons != undefined) this.ballons = this.map.dataset.balloons.split(';');
		this.message = this.map.dataset.message;
		if(this.map.dataset.stylish != undefined) this.stylish = true


		if (window.ymapsReady) {
			this.initMap();
		} else {
			document.addEventListener('ymaps-ready', () => this.initMap());
		}
	}

	initMap() {
		if (!window.ymaps) return false;
		ymaps.ready(()=> {
			let node = this.map;
			node.innerHTML = '';

			let map = new ymaps.Map(node, {
				center: this.center,
				zoom: this.zoom,
				controls: []
			},{
				yandexMapDisablePoiInteractivity: true,
				suppressMapOpenBlock: true
			});
			if(this.cords){
				if(this.stylish){
					function getRandomInt(min, max) {
						return Math.floor(Math.random() * (max - min)) + min;
					}

					this.cords.forEach((cord, index) => {
						map.geoObjects.add(new ymaps.Placemark(cord.split(','), {
							iconContent: index+1,
							balloonContent: this.ballons && this.ballons[index]?this.ballons[index]:''
						},{
							iconColor: 'rgb('+getRandomInt(0,255)+', '+getRandomInt(0,255)+', '+getRandomInt(0,255)+')'

						}))

					});
				} else {
					this.cords.forEach(cord => {
						map.geoObjects.add(new ymaps.Placemark(cord.split(',')))
					});
				}

			}
			map.events.add('click', (e)=>{
				map.balloon.close();
				map.balloon.open(e.get("coords"),{content: this.message?this.message:''});

			})
			if (map.behaviors.isEnabled("scrollZoom")) map.behaviors.disable("scrollZoom");
			map.behaviors.enable("dblClickZoom");
			map.behaviors.enable("drag");
			if (map.behaviors.isEnabled("rightMouseButtonMagnifier")) map.behaviors.disable("rightMouseButtonMagnifier");
			map.controls.add(new ymaps.control.ZoomControl({
				options: {
					size: "small",
					position: {
						left: '2rem',
						top: '16rem'
					}
				}
			}));
		});

	}

}

